// extracted by mini-css-extract-plugin
export default {"tabs":"ProfilePageBots_tabs__okMi4","tab":"ProfilePageBots_tab__T69Pe","active":"ProfilePageBots_active__H5lwM","botsContainer":"ProfilePageBots_botsContainer__Rmw+7"};